module.exports = __webpack_public_path__ + "img/ron_d_3.668a7ed6.png";